var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLanguages = function SvgLanguages(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1569"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1571",
    transform: "translate(0 .37)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 17,
    fill: "currentColor",
    "data-name": "Ellipse 282",
    transform: "translate(0 -.36)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    "data-name": "Group 1570",
    transform: "translate(0.3 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1569"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 280",
    transform: "translate(6.93 5.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 10.97,
    r: 10.97,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.97,
    cy: 10.97,
    r: 10.47
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 281",
    transform: "translate(11.54 5.8)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.35,
    cy: 10.97,
    stroke: "none",
    rx: 6.35,
    ry: 10.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.35,
    cy: 10.97,
    rx: 5.85,
    ry: 10.47
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.9 5.77v21.36",
    "data-name": "Line 163"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.58 16.6H7.22",
    "data-name": "Line 164"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.81 10.43h16.16",
    "data-name": "Line 165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95 22.26h17.89",
    "data-name": "Line 166"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLanguages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/languages.1c31ecd0.svg";
export { ForwardRef as ReactComponent };